import React from 'react'
import styled from 'styled-components'

const SkillProgress = ({item}) => {
  return (
    <Wrapper item={item}>
        <div className='text-container'>
            <p>{item.SkillName}</p>
            <p>{item.percentage}%</p>
        </div>
          <div className="progress-container">
            <div style={{width:item.percentage+'%' }} className="progress-inner">

            </div>

          </div>
    </Wrapper>
  )
}

const Wrapper  = styled.section`
margin-top: 1rem;
p{
    font-size: small;
    /* margin: .3rem 0; */
}
.text-container{
    display: flex;
    justify-content: space-between;

}
 .progress-container{
    background-color: #e9ecef;
    width: 100%;
    height: 0.4rem;
    border: 1px solid #e9ecef;
  }
  .progress-inner{
    background-image: linear-gradient(to right, #d40b7e, #dc368e, #e34f9e, #ea64ae, #f078bd);
    
    /* width: ${({item}) => item.percentage}%; */
    height: 0.4rem;
    border-top-right-radius: 2rem;
    border-bottom-right-radius: 2rem;

  }

`

export default SkillProgress